import { CreditCard } from 'lucide-react'

import { formatPlnMinor } from '@/lib/money'
import { META, MICRO } from '@/lib/typography'
import { cn } from '@/lib/utils'

/**
 * "Zapłać online" — the hand-off to Przelewy24 (spec §18 · Etap P).
 *
 * A plain `<a>`, and that is the design rather than an omission. `href` points
 * at `/api/platnosci/zaplac/<id>`, which registers a fresh gateway token per
 * visit and redirects: no token in the markup to go stale, no client state to
 * lose between the click and the redirect, and nothing to do on a page that has
 * already re-rendered. The codebase this was ported from did the same hand-off
 * from a `useEffect` and lost buyers whenever the cart unmounted first.
 *
 * Rendered ONLY when a gateway is configured — the caller passes `null` and
 * this disappears, leaving the bank transfer as the one way to pay, exactly as
 * before Etap P.
 */
export function PayOnline({
  href,
  amountGrossMinor,
  /** Is there a transfer instruction under this one? Changes one sentence. */
  transferBelow = true,
}: {
  href: string
  amountGrossMinor: number
  transferBelow?: boolean
}) {
  return (
    <div className="flex flex-col gap-2.5">
      <a
        href={href}
        className={cn(
          META,
          'inline-flex items-center justify-center gap-2 rounded-full bg-white px-5 py-3 font-semibold text-neutral-900 transition-colors hover:bg-white/90',
        )}
      >
        <CreditCard size={15} aria-hidden="true" />
        Zapłać online — {formatPlnMinor(amountGrossMinor)}
      </a>
      <p className={cn(MICRO, 'leading-relaxed text-white/55')}>
        BLIK, karta, szybki przelew, Apple Pay i Google Pay. Przeniesiemy Cię do Przelewy24
        {transferBelow ? ', a jeśli wolisz zwykły przelew — dane są niżej.' : '.'}
      </p>
    </div>
  )
}
